import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});
export async function createQuestion(body:any) {
    try{
  
     const response = await authService.apiCall(`${BASE_URL}/bank-questions`, {
         method: "POST",
       
         body: JSON.stringify(body)
     });

     const data = await response.json();
     if (!response.ok || !data.success) {
         if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
             throw new Error("Forbidden: You do not have permission to access this resource.");
         }
         throw new Error("Failed to fetch");
     }
     return data;
 } catch (error: any) {
     throw new Error(error);
 }
}

// Function to handle fetch requests
export async function fetchAllDataApi( options: RequestInit = {}): Promise<any> {

 
    try {
      const response = await authService.apiCall(`${BASE_URL}/bank-questions`, {
        ...options,
       
      });
  
      const data = await response.json();
  
      if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
      }
      return data;
    } catch (error: any) {
      //////console.log(error)
      throw new Error(error);
    }
  }

// Function to handle fetch requests
export async function fetchDataApi(url: string, options: RequestInit = {}): Promise<any> {

   
    try {
      const response = await authService.apiCall(`${BASE_URL}/${url}`, {
        ...options,
      
      });
  
      const data = await response.json();
  
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
      }
      return data;
    } catch (error: any) {
      //////console.log(error)
      throw new Error(error);
    }
  }


  export async function createSurvey(body:any) {
    try{
  
  
     const response = await authService.apiCall(`${BASE_URL}/publicSurvey`, {
         method: "POST",
        
         body: JSON.stringify(body)
     });

     

     const data = await response.json();
     if (!response.ok || !data.success) {
         if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
             throw new Error("Forbidden: You do not have permission to access this resource.");
         }
         throw new Error("Failed to fetch");
     }
     return data;
 } catch (error: any) {
     throw new Error(error);
 }
}



export async function deleteSurveyApi(id: string): Promise<void> {
  try {
   
    const response = await authService.apiCall(`${BASE_URL}/publicSurvey/${id}`, {
    method: 'DELETE',
    
    });
    if (!response.ok) {
      throw new Error('Failed to delete survey');
    }
    return response.json(); // Return the response data
    // Optionally return response data if needed
  } catch (error) {
    throw new Error('Failed to delete survey');
  }
}
  

export async function deleteQuestionApi(id: string): Promise<void> {
  try {
   
    const response = await authService.apiCall(`${BASE_URL}/bank-questions/${id}`, {
     method: 'DELETE',
    
    });
    if (!response.ok) {
      throw new Error('Failed to delete question');
    }
    return response.json(); // Return the response data
    // Optionally return response data if needed
  } catch (error) {
    throw new Error('Failed to delete question');
  }
}

export async function getSurveyQuestionByQuarter(riskId: any, quarter: string,year:number): Promise<any> {
    try {
     
      const response = await authService.apiCall(`${BASE_URL}/survey-assessment/${riskId}/quarter/${quarter}/year/${year}`, {
        method: 'GET',
     
      });
  
      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
      }
      return data;
    } catch (error: any) {
      throw new Error(error);
    }
  
}

export async function getSurveyQuestionByQuarterByPage(riskId: any, quarter: string,year:number,page:number,size:number): Promise<any> {
  try {
   
    const response = await authService.apiCall(`${BASE_URL}/survey-assessment/${riskId}/quarter/${quarter}/year/${year}/page/${page}/size/${size}`, {
      method: 'GET',
     
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error);
  }

}


export async function assesstQuestion(body: any): Promise<any> {
  try {
    
    
    const response = await authService.apiCall(`${BASE_URL}/survey-assessment`, {
      method: 'POST',
   
      body: JSON.stringify(body),
    });

      const data = await response.json();
      if (!response.ok || !data.success) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          throw new Error("Failed to fetch");
      }
      return data;
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function getRCSAByPage( quarter: string, year: number, page: number, pageSize: number): Promise<any> {
  try {
  
    const response = await authService.apiCall(`${BASE_URL}/survey-assessment/compliance-data/quarter/${quarter}/year/${year}/page/${page}/size/${pageSize}`, {
      method: 'GET',
    
    });
    const data = await response.json();

    return data;
  } catch (error: any) {
    console.error("Error in fetchOneApi:", error); // Log the error
    throw new Error(error);
  }
}

export async function updateSurveyApi(id: any, body: any): Promise<void> {
  try {
  
    const fullUrl = `${BASE_URL}/publicSurvey/${id}`; // Construct the full URL
   
    const response = await authService.apiCall(fullUrl, {
    
      method: "PATCH",
     
      body: JSON.stringify(body),
    });

    const data = await response.json();
    //console.log("Update API Response:", data); // Log the response

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to update");
    }

    return data; // Return the response data
  } catch (error) {
    console.error("Error in updateRiskApi:", error); // Log the error
    throw new Error("Failed to update risk");
  }
}



export async function uploadExcelForRCSA(file: File) {
 
  try {
      const formData = new FormData();
      formData.append('file', file);

      // Do not set 'Content-Type' when using FormData

      const response = await authService.apiCall(`${BASE_URL}/survey-assessment/excel`, {
          method: "POST",
          body: formData,
      });

      if (!response.ok) {
          throw new Error('Failed to upload Excel file');
      }

      return response.json();
  } catch (error) {
      throw new Error('Failed to upload Excel file');
  }
}




export async function uploadExcelForRiskProfile(file: File) {

  try {
      const formData = new FormData();
      formData.append('file', file);

   
      const response = await authService.apiCall(`${BASE_URL}/survey-assessment/excelForRiskProfile`, {
          method: "POST",
         
          body: formData,
      
      });

      if (!response.ok) {
          throw new Error('Failed to upload Excel file');
      }

      return response.json();
  } catch (error) {
      throw new Error('Failed to upload Excel file');
  }
}


export async function fetchOneSurveyApi(url: string, options: RequestInit = {}): Promise<any> {
  try {
   

    const fullUrl = `${BASE_URL}/${url}`; // Construct the full URL
    //console.log("Fetching from URL:", fullUrl); // Log the URL

    const response = await authService.apiCall(fullUrl, {
      ...options,
     
    });

    const data = await response.json();
    //console.log("API Response:", data); // Log the response

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {

   console.error("Error in fetchOneApi:", error); // Log the error
    throw new Error(error);
  }
}


export const updateQuestionApi = async (id: string, data: any) => {
  try {
    const response = await authService.apiCall(`${BASE_URL}/bank-questions/${id}`, {
      method: 'PATCH',
    
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to update question');
    }

    const result = await response.json();
    return result;
  } catch (error: any) {
    console.error('Error in updateQuestionApi:', error);
    throw error;
  }
};



export async function fetchOneQuestionApi(url: string, options: RequestInit = {}): Promise<any> {
  try {
   

    const fullUrl = `${BASE_URL}/${url}`; // Construct the full URL
    //console.log("Fetching from URL:", fullUrl); // Log the URL

    const response = await authService.apiCall(fullUrl, {
      ...options,
 
    });

    const data = await response.json();
    //console.log("API Response:", data); // Log the response

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }

    return data;
  } catch (error: any) {
    console.error("Error in fetchOneApi:", error); // Log the error
    throw new Error(error);
  }
}

export async function fetchBankQuestionsApi(
  quarter: string,
  year: string,
  options: RequestInit = {}
): Promise<any> {
 

  const query = new URLSearchParams({ quarter, year }).toString();

  try {
    const response =await authService.apiCall(`${BASE_URL}/bank-questions/with-controls?${query}`, {
      ...options,
    
    });

    const data = await response.json();

    if (!response.ok) {
      if (
        response.status === 401 ||
        response.status === 403 ||
        data.message === "Forbidden access"
      ) {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch bank questions.");
    }

    return data;
  } catch (error: any) {
    throw new Error(error.message || "Unexpected error");
  }
}
